var React = require('react');

function MissionsBigQuotes (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M82 9.35304L74.1355 16.0788C70.2907 19.3716 68.3683 23.4001 68.3683 28.1642C68.3683 31.0367 70.081 34.3645 73.5064 38.1478C76.9318 41.931 78.6445 45.399 78.6445 48.5517C78.6445 58.8506 73.5763 64 63.4399 64C52.6044 64 47.1867 57.7997 47.1867 45.399C47.1867 26.8331 56.4493 11.7001 74.9744 0L82 9.35304ZM34.8133 9.35304L26.9488 16.0788C23.104 19.3716 21.1816 23.4001 21.1816 28.1642C21.1816 31.0367 22.8943 34.3645 26.3197 38.1478C29.7451 41.931 31.4578 45.399 31.4578 48.5517C31.4578 58.8506 26.3896 64 16.2532 64C5.41773 64 0 57.7997 0 45.399C0 26.8331 9.26257 11.7001 27.7877 0L34.8133 9.35304Z","fill":"#0EE9C4"}));
}

MissionsBigQuotes.defaultProps = {"width":"82","height":"64","viewBox":"0 0 82 64","fill":"none"};

module.exports = MissionsBigQuotes;

MissionsBigQuotes.default = MissionsBigQuotes;
